import * as React from 'react';
import { IDocument, ISeedIcon, ISeedProduct } from 'src/infrastructure/interfaces';
import MarkdownRenderer from '../../Editor/components/CropPageView/common/MarkdownRenderer';
import './TypeSeedBullets.css';

export interface ITypeSeedBullets {
  product: ISeedProduct;
  document?: IDocument;
}

export default class TypeSeedBullets extends React.Component<ITypeSeedBullets> {
  
  render() {
    const docType = this.props.document ? this.props.document.type : "";
    const iconCount = this.props.product.icons.map((icon: ISeedIcon) => ({
      src: icon.src,
      name: icon.name,
    })).length;
    const hasIcons = iconCount > 0;


    return (
      <div className={`${docType} ${hasIcons ? 'has-icons' : 'no-icons'} bullet-points`}>
        <MarkdownRenderer markdown={this.props.product.bulletPointMarkdown} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Products/components/TypeSeedBullets.tsx